module.exports = __webpack_public_path__ + "media/img/frontend_application/solution/videoprod-25b6bbddf57756e067059253d27b28e9.jpg";